export const css = {
    root: 'B74Yb0-8',
    row: '_1EC9BWvN',
    primary: '_3allVXmN',
    secondary: '_3cPkL0Z9',
    sticky: '_3fVySqP3',
    leading: '_1I8wl4et',
    title: '_3lnhBlrS',
    actions: '_2WUcuMk7',
    action: 'zKyrP8p4',
    trailing: '_3_kNAzIG',
    spacer: '_2ZaruXED',
    ' _key': 'certwise-theme/dojo/header'
};
export default css;
